import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCompass = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#compass_svg__a)">
      <path
        fill="#263E6A"
        d="M11.98 21.6a9.53 9.53 0 0 1-5.657-1.861 9.54 9.54 0 0 1-3.81-6.281 9.54 9.54 0 0 1 1.748-7.135 9.53 9.53 0 0 1 6.28-3.81 9.53 9.53 0 0 1 5.804.928.32.32 0 0 1-.29.57 8.9 8.9 0 0 0-5.417-.867A8.9 8.9 0 0 0 4.776 6.7a8.9 8.9 0 0 0-1.631 6.66A8.9 8.9 0 0 0 6.7 19.225a8.9 8.9 0 0 0 6.66 1.631 8.9 8.9 0 0 0 5.863-3.556 8.9 8.9 0 0 0 1.631-6.66 8.9 8.9 0 0 0-1.407-3.623.319.319 0 1 1 .53-.355 9.5 9.5 0 0 1 1.508 3.881 9.54 9.54 0 0 1-1.747 7.135 9.54 9.54 0 0 1-6.281 3.81 10 10 0 0 1-1.479.113m.707-4.06 3.428-9.308a.32.32 0 0 0-.407-.411l-9.302 3.32a.32.32 0 0 0 .02.609l4.485 1.279 1.167 4.482a.32.32 0 0 0 .293.238h.016a.32.32 0 0 0 .3-.208m2.593-8.888-2.84 7.712-.957-3.673a.32.32 0 0 0-.221-.226l-3.703-1.056z"
      />
    </g>
    <defs>
      <clipPath id="compass_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCompass;
